export const EVENT_HANDLER = {
  ON_CANCEL_ALL: 'onCancelAll',
};
